// custom: T7 — módulo Vuex namespaced para favoritas de conversa por agente.
// Namespace: 'cwCustomConversationFavorites' (nome da chave no objeto modules do store)
// Estado: Set de ids das conversas favoritadas pelo agente atual.
// Toggle otimista: atualiza o Set local antes da resposta da API e reverte em erro.
import ConversationFavoritesAPI from 'dashboard/api/cw_custom/conversationFavorites';

const state = {
  // Set preserva O(1) em has(). Vuex não é reativo a mutations em Set, por isso
  // substituímos sempre por um novo Set (imutabilidade explícita).
  favoriteIds: new Set(),
};

export const getters = {
  // Retorna o Set atual. Consumidor faz has(id) para verificar estado.
  getFavoriteIds: $state => $state.favoriteIds,
};

export const mutations = {
  SET_FAVORITE_IDS($state, ids) {
    $state.favoriteIds = new Set(ids);
  },

  ADD_FAVORITE($state, id) {
    $state.favoriteIds = new Set([...$state.favoriteIds, id]);
  },

  REMOVE_FAVORITE($state, id) {
    const next = new Set($state.favoriteIds);
    next.delete(id);
    $state.favoriteIds = next;
  },
};

export const actions = {
  // Carrega todos os ids de favoritas do agente atual. Chamado no onMounted do ChatList.
  async load({ commit }, accountId) {
    try {
      const { data } = await ConversationFavoritesAPI.index(accountId);
      commit('SET_FAVORITE_IDS', data.conversation_ids || []);
    } catch {
      // Degradação silenciosa: a aba Favoritas fica vazia mas não quebra a UI.
    }
  },

  // Toggle otimista: aplica localmente antes da resposta e reverte em erro.
  async toggle({ commit, state: $state }, { accountId, conversationId }) {
    const wasAlreadyFavorited = $state.favoriteIds.has(conversationId);

    // Atualização otimista imediata
    if (wasAlreadyFavorited) {
      commit('REMOVE_FAVORITE', conversationId);
    } else {
      commit('ADD_FAVORITE', conversationId);
    }

    try {
      const { data } = await ConversationFavoritesAPI.toggle(
        accountId,
        conversationId
      );
      // Sincroniza com a resposta do servidor para garantir consistência
      if (data.favorited) {
        commit('ADD_FAVORITE', conversationId);
      } else {
        commit('REMOVE_FAVORITE', conversationId);
      }
    } catch {
      // Reverte ao estado anterior em erro (rede offline, 422, etc.)
      if (wasAlreadyFavorited) {
        commit('ADD_FAVORITE', conversationId);
      } else {
        commit('REMOVE_FAVORITE', conversationId);
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
